import React, { useEffect } from "react";
import * as Styled from "./OutletForm.styled";
import { ILibraryOutlet, IProfile, selectTheme } from "../../../libs";
import { useFormik } from "formik";
import Select from "react-select";

export interface OutletFormData {
  outletName: string;
  outletUrl: string;
  linkedProfileId: string;
}

export interface OutletFormProps {
  outlet?: ILibraryOutlet | null;
  onSave: (data: OutletFormData) => void;
  onCancel: () => void;
  profiles: IProfile[];
  isEdit?: boolean;
}

export const OutletForm: React.FC<OutletFormProps> = ({
  outlet,
  onSave,
  onCancel,
  profiles,
  isEdit = false,
}) => {

  const formik = useFormik({
    initialValues: {
      outletName: outlet?.outletName || "",
      outletUrl: outlet?.outletUrl || "",
      linkedProfileId: outlet?.linkedProfileId || "",
    },
    validate: (values) => { },
    onSubmit: (values) => {
      onSave(values);
    },
  })

  useEffect(() => {

  }, [outlet]);

  return (
    <Styled.FormContainer>
      <form onSubmit={formik.handleSubmit}>
        <Styled.FormGroup>
          <Styled.Label htmlFor="outletName">Outlet Name</Styled.Label>
          <Styled.Input
            id="outletName"
            name="outletName"
            type="text"
            placeholder="Enter outlet name"
            value={formik.values.outletName}
            onChange={formik.handleChange}
            required
          />
        </Styled.FormGroup>

        <Styled.FormGroup>
          <Styled.Label htmlFor="outletUrl">Outlet URL(s)</Styled.Label>
          <Styled.Input
            id="outletUrl"
            name="outletUrl"
            type="text"
            placeholder="example.com, https://example1.com, example2.com"
            value={formik.values.outletUrl}
            onChange={formik.handleChange}
            required
          />
          <Styled.HelpText>
            You can enter multiple URLs separated by commas. Use full URLs with "http://" or "https://", or just the domain name.
          </Styled.HelpText>
        </Styled.FormGroup>

        <Styled.FormGroup>
          <Styled.Label htmlFor="linkedProfileId">Linked Profile ID</Styled.Label>
          <Select
            className="custom-select"
            styles={selectTheme.singleSelect()}
            options={profiles.map(profile => ({
              value: profile.profileId,
              label: `${profile.profileName} (ID: ${profile.profileId})`
            }))}
            isClearable
            placeholder="Select a profile"
            value={profiles.find(p => p.profileId === formik.values.linkedProfileId) ? {
              value: formik.values.linkedProfileId,
              label: profiles.find(p => p.profileId === formik.values.linkedProfileId)?.profileName,
            } : null}
            onChange={(selectedOption) => {
              formik.setFieldValue(
                "linkedProfileId",
                selectedOption?.value || "",
              );
            }}
          />
        </Styled.FormGroup>

        <Styled.ButtonGroup>
          <Styled.CancelButton type="button" onClick={onCancel}>
            Cancel
          </Styled.CancelButton>
          <Styled.SaveButton type="submit">
            {isEdit ? "Update" : "Create"}
          </Styled.SaveButton>
        </Styled.ButtonGroup>
      </form>
    </Styled.FormContainer>
  );
};
